import { NgModule } from "@angular/core";
import { HasAppAccessPipe } from "./app-access/has-app-access.pipe";
import { HasNoAppAccessPipe } from "./app-access/has-no-app-access.pipe";

@NgModule({
  declarations: [
    HasAppAccessPipe,
    HasNoAppAccessPipe
  ],
  exports: [
    HasAppAccessPipe,
    HasNoAppAccessPipe
  ]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/app/common/pipes/pipes.module.ts